import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon"
import WeatherTemperature from "./WeatherTemperature"
import "./weather.css";

export default function WeatherInfo(props) {
    return (
       <div className="container WeatherInfo">
        <div className="row">
            <div className="col-8">
               <h1>{props.data.city}</h1>
         <ul>
            <li> <span>Last Updated:  </span>
    <FormattedDate date={props.data.dateDay} />
                </li>
            <li className="text-capitalize">
                {props.data.description}</li>

            <li>
                <span>Humidity: <span className="highlight">{Math.round(props.data.humidity)}%</span></span>
                <span> Wind: <span className="highlight">{Math.round(props.data.wind)}km/h</span></span>
            </li>
                </ul>
        </div>
         <div className="col-1 Icon"> <WeatherIcon code={props.data.icon} size={70} /> </div>
            <div className="col-1 TemperatureDisplay">
                <WeatherTemperature celsius={props.data.temperature} />
            </div>
        </div>
         </div>
    )
}